module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/univ-arizona-bcb47765b79b2c7ea04816ff6120701d.svg";